export default {
	validate: {},
	locales: {
		en: 'Английский',
		ru: 'Русский',
		uk: 'Украинский'
	},
	cities: {
		kyv: 'Киев',
		umn: 'Умань',
		vin: 'Винница'
	},
	menu: {
		Login: 'Вход',
		Register: 'Регистрация',
		Dashboard: 'Доска'
	},
	buttons: {
		confirm: 'Подтвердить',
		cancel: 'Отменить',
		repeat: 'Повторить',
		ok: 'OK'
	},
	pages: {
		Login: {
			title: 'Вход в систему',
			submit: 'Войти',
			confirm: 'Подтвердите вход',
			withoutSMS: 'Нет смс или изменить номер?',
			problemWithCode: 'Не можете получить код подтверждения?',
			changePhone: 'Изменить номер телефона',
			dontGetSms: 'Не получено SMS',
			form: {
				phoneNumber: {
					countrySelectorLabel: 'Код страны',
					countrySelectorError: 'Выберите страну',
					phoneNumberLabel: 'Номер телефона',
					example: 'Пример: '
				}
			}
		},
		Dashboard: {
			streets: {
				noResults: 'Результаты не совпадают',
				0: 'Откуда - Начните вводить для поиска ...',
				1: 'Куда - Начните вводить для поиска ...'
			},
			house: 'Дом',
			statuses: {
				searching: 'Поиск',
				'driver-assigned': 'Водитель найден',
				arrived: 'Водитель прибыл',
				cancelled: 'Отменено'
			},
			reverseSearch: 'Выбрать точку на карте',
			outCity: 'За городом',
			continueSearch: 'Продолжайте поиск ...',
			rate: 'Тариф',
			options: 'Опции',
			driver: 'Водитель',
			others: 'других',
			yourOrder: 'Ваш заказ',
			orderTaxi: 'Заказать такси',
			createAnotherOrder: 'Создать другой заказ',
			canCancelOrder: 'Вы действительно хотите отменить данный заказ?',
			cancelDescription: 'Через частые отмены уже принятых водителями заказов, возможность создавать новые заказы может быть заблокирована на некоторое время.',
			noItems: 'Ничего не найдено',
			comment: 'Комментарий'
		},
		404: {
			title: 'Упсс!',
			text: 'Похоже, ты на неизведанной территории. Мы еще не знаем об этой странице. К счастью, мы знаем дорогу назад.',
			return: 'Назад'
		}
	},
	messages: {
		info: {
			pushLoginCode: 'На ваш телефон отправлено SMS с кодом подтверждения'
		},
		success: {
			login: 'Добро пожаловать к нам!'
		},
		error: {
			incorrectConfirmCode: 'Введен неверный код подтверждения',
			unknown: 'Неизвестная ошибка',
			incorrectEnterNumber: 'Введите число'
		}
	},
	noDataText: 'not items'
}
